document.addEventListener('DOMContentLoaded', function() {
    let selectedTariffId = null;
    
    // --- 1) Tariff trigger: pre-fill tariff in popup form ---
    const tariffButtons = document.querySelectorAll('.ps-tariff-trigger a');
    
    tariffButtons.forEach(function(button) {
        button.addEventListener('click', function() {
            selectedTariffId = button.id;
        });
    });
    
    jQuery(document).on('elementor/popup/show', function() {
        if (!selectedTariffId) return;

        const maxAttempts = 10;
        let attempts = 0;

        const interval = setInterval(function() {
            const select = document.querySelector('.elementor-popup-modal select[name="form_fields[tariffField]"]');
            
            if (select) {
                clearInterval(interval);
                const option = Array.from(select.options).find(opt => opt.value === selectedTariffId);
                if (option) {
                    select.value = option.value;
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                    selectedTariffId = null;
                }
            } else if (++attempts >= maxAttempts) {
                clearInterval(interval);
                selectedTariffId = null; // Reset if not found after max attempts
            }
        }, 50);
    });

    // --- 2) Pricing table: reliably open popup on every click ---
    document.querySelectorAll('a[href="#tarifas-form"]').forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            elementorProFrontend.modules.popup.showPopup({ id: 822 });
        });
    });
});
